var InfusionsoftLibrary = function() {
  var _url;
  var _customerId;

  return {
    init: function(url, customerId) {
      _url = url;
      _customerId = customerId;
    },
    createCustomer: function(callback) {
      $.ajax({
        url: _url + '/infusionsoft',
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          customer_id: _customerId
        }),
        success: function(response) {
          window.localStorage.removeItem('newAccount');
          window.localStorage.removeItem('newLogin');
          if (callback) {
            callback(response);
          }
        },
        error: function(response) {
          console.log('Failed to get response from infusionsoft server.');
          console.log(response);
        },
      });
    },
    handleLogin: function(callback) {
      $.ajax({
        url: _url + '/infusionsoft',
        method: 'PUT',
        contentType: 'application/json',
        data: JSON.stringify({
          customer_id: _customerId
        }),
        success: function(response) {
          window.localStorage.removeItem('newAccount');
          window.localStorage.removeItem('newLogin');
          if (callback) {
            callback(response);
          }
        },
        error: function(response) {
          console.log('Failed to get response from infusionsoft server.');
          console.log(response);
        },
      });
    }
  }
}();

$(document).ready(function() {
  // If the localStorage is utilized and the customer is logged in check the flags
  if (window.localStorage && window.customerId) {
    var url = "https://ilqwixyr71.execute-api.us-east-2.amazonaws.com/prod";
    InfusionsoftLibrary.init(url, window.customerId);
    
    if (window.localStorage.hasOwnProperty('newAccount')) {
      InfusionsoftLibrary.createCustomer();
  	} else if (window.localStorage.hasOwnProperty('newLogin')) {
      InfusionsoftLibrary.handleLogin();
    }        
  }
});